// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Ubuntu:wght@400;500&display=swap);"]);
// Module
exports.push([module.id, "", ""]);
// Exports
module.exports = exports;
